// Central tour configuration
import type { TourTabValue, TourConfig } from './types';
import { CALCULATOR_TOUR } from './calculatorTour';
import { FEEDS_TOUR } from './feedsTour';
import { VASTU_TOUR } from './vastuTour';
import { CHAT_TOUR } from './chatTour';
import { ADMIN_TOUR } from './adminTour';
import { FAMILY_TOUR } from './familyTour';

export const TOUR_CONFIGS: Record<TourTabValue, TourConfig> = {
  calculator: { steps: CALCULATOR_TOUR, autoStart: true },
  feeds: { steps: FEEDS_TOUR },
  vastu: { steps: VASTU_TOUR },
  chat: { steps: CHAT_TOUR },
  admin: { steps: ADMIN_TOUR },
  family: { steps: FAMILY_TOUR },
};

export * from './types';
export { CALCULATOR_TOUR, FEEDS_TOUR, VASTU_TOUR, CHAT_TOUR, ADMIN_TOUR, FAMILY_TOUR };
